import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MicroSentryService } from '@micro-sentry/angular';
import { Severity } from '@micro-sentry/core';
import Keycloak from 'keycloak-js';
import { isNil } from 'lodash';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthFacade } from '@store-common/facade/auth-facade';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private keycloak: Keycloak = inject(Keycloak);
  private readonly sentry = inject(MicroSentryService, { optional: true });

  constructor(private authFacade: AuthFacade) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.keycloak.token;

    if (!token) {
      return next.handle(request);
    }

    const clonedRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next.handle(clonedRequest).pipe(
      catchError((event) => {
        if (event instanceof HttpErrorResponse) {
          !isNil(this.sentry) &&
            this.sentry.captureMessage(JSON.stringify(event), Severity.error);

          const UNAUTHORIZED = 401;
          const FORBIDDEN = 403;

          switch (event.status) {
            case UNAUTHORIZED || FORBIDDEN: {
              environment.production && this.authFacade.logout(true);
              break;
            }

            default:
              break;
          }
        }

        return throwError(() => event);
      })
    );
  }
}
